import classNames from 'classnames';
import React from 'react';

import * as styles from './wistia.module.css';

interface WistiaEmbedProps {
	isModule: boolean;
	wistiaEmbedCode: string;
}

export function WistiaEmbed({ isModule, wistiaEmbedCode }: WistiaEmbedProps) {
	return (
		<div
			className={classNames(
				isModule && styles.moduleContainer,
				styles.wistiaContainer
			)}
		>
			<div dangerouslySetInnerHTML={{ __html: wistiaEmbedCode }} />
		</div>
	);
}
